import { ComponentPropsWithoutRef } from 'react'

import { isDevelopment } from '@/utils/isDevelopment'

import { ContentfulButton } from '@/components/Contentful/common/ContentfulButton'
import { Warning } from '@/components/Warning'

import { useEntryField } from '../CaseStudy.hooks'

type BaseProps = {
	textFieldPath?: string
	urlFieldPath?: string
}

type Props = BaseProps &
	Omit<ComponentPropsWithoutRef<typeof ContentfulButton>, 'textField' | 'urlField'>
export function CaseStudyButton({ textFieldPath, urlFieldPath, ...rest }: Props) {
	const textField = useEntryField({ fieldPath: textFieldPath })
	const urlField = useEntryField({ fieldPath: urlFieldPath })

	if ('error' in urlField) {
		if (isDevelopment()) {
			return <Warning className={rest.className}>{urlField.error}</Warning>
		}
		return null
	}

	if (typeof urlField.data !== 'object' || urlField.data === null) {
		if (isDevelopment()) {
			return <Warning className={rest.className}>field.data is not an object</Warning>
		}

		return null
	}

	if (!('url' in urlField.data) || typeof urlField.data?.url !== 'string') {
		if (isDevelopment()) {
			return (
				<Warning className={rest.className}>
					url does not exist in `field.data` or is not of type `string`
				</Warning>
			)
		}

		return null
	}

	return (
		<ContentfulButton {...rest} textField={textField} urlField={{ data: urlField.data?.url }} />
	)
}
